module.exports = __webpack_public_path__ + "media/images/operative-new-869d9190.svg";